import { Component, inject, input, model, output, signal } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { getRandomId } from 'src/app/shared/extensions/string.extensions';

@Component({
    selector: 'app-standard-colorpicker',
    templateUrl: './standard-colorpicker.component.html',
    styleUrls: ['./standard-colorpicker.component.scss'],
    standalone: false,
})
export class StandardColorpickerComponent implements ControlValueAccessor {
    public control = inject(NgControl, { self: true, optional: true });

    public readonly label = input<string>();
    public readonly hint = input<string>();
    public readonly validationError = input<string>();
    public readonly disabled = model<boolean>(false);

    public readonly ColorPickerChanged = output<string>();

    public readonly id = getRandomId();
    public readonly data = signal<string | null>(null);

    private isChanged = false;
    private isSetEmpty = false;

    constructor() {
        if (this.control) {
            this.control.valueAccessor = this;
        }
    }

    public onChangeFn = (_: string) => {
        return;
    };

    public onTouchedFn = () => {
        return;
    };

    public writeValue(value: string): void {
        this.data.set(value ?? null);
    }

    public registerOnChange(fn: (value: string) => void): void {
        this.onChangeFn = fn;
    }

    public registerOnTouched(fn: () => void): void {
        this.onTouchedFn = fn;
    }

    public setDisabledState(isDisabled: boolean): void {
        this.disabled.set(isDisabled);
    }

    public onChange(): void {
        const current = this.data();
        this.onChangeFn(current);
        this.isSetEmpty = current === '';
        this.isChanged = false;
    }

    public onInput(): void {
        this.onChange();
        this.isChanged = true;
    }

    public onColorPickerChanged(value: string): void {
        const current = this.data();
        if (current && !value.includes(current) && this.isChanged) {
            return;
        }
        this.ColorPickerChanged.emit(value);
        this.data.set(value);
    }

    public onColorPickerSelect(eventValue: string, value: string): void {
        if (this.isSetEmpty) {
            this.data.set('');
        }
        if (eventValue != '') {
            if (this.isSetEmpty) {
                this.data.set('');
            } else if (value != '' && value.length != 7) {
                this.data.set(value);
            } else {
                this.data.set(eventValue);
            }
            this.ColorPickerChanged.emit(this.data());
        } else {
            this.ColorPickerChanged.emit(value);
        }

        this.isSetEmpty = false;
    }
}
